import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {ConfigurationService} from './configuration.service';
import {UrlEndpoints} from '../definitions/url-endpoints';
import {GeneralService} from './general.service';
import {DefineHostAddressService} from './define-host-address.service';
import {AuthenticationService} from './auth/authentication.service';
import {catchError, timeout} from 'rxjs/operators';
import {of} from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class TestConnectionService {

    constructor(private http: HttpClient,
                private configurationService: ConfigurationService,
                private urlEndpoints: UrlEndpoints,
                private generalService: GeneralService,
                private defineHost: DefineHostAddressService,
                private authService: AuthenticationService) {
    }

    async pingServer() {
        return new Promise((resolve, reject) => {
            this.http.get(this.configurationService.buildUrl(this.urlEndpoints.testConnectionEndpoint))
                .pipe(timeout(5000)).toPromise().then(data => {
                resolve(data);
            }).catch(err => {
                this.defineHost.defineHostAdd().then(() => {
                    resolve(true);
                }).catch(() => {
                    reject(err);
                });
            });
        });
    }

    async checkAuthServer() {
        return new Promise((resolve, reject) => {
            this.authService.getAuthenticationObservable().toPromise().then(data => {
                console.log(data);
                resolve(data);
            }).catch(err => {
                this.defineHost.defineHostAddAuth().then(() => {
                    // alert('Your Api Key is incorrect');
                    resolve(true);
                }).catch(() => {
                    reject(err);
                });
            });
        });
    }
}
